import { render, staticRenderFns } from "./logs-data.vue?vue&type=template&id=1490c752&scoped=true"
import script from "./logs-data.vue?vue&type=script&lang=js"
export * from "./logs-data.vue?vue&type=script&lang=js"
import style0 from "./logs-data.vue?vue&type=style&index=0&id=1490c752&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1490c752",
  null
  
)

export default component.exports